var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showInitial)?_c('span',{staticClass:"d-flex align-items-center"},[(_vm.isSaved)?_c('i',{staticClass:"ki ki-check icon-xs text-success ml-2 mr-2"}):_c('i',{staticClass:"fas fa-clock icon-xs ml-2 mr-2"}),_c('span',{staticClass:"text-muted"},[_vm._v(" "+_vm._s(_vm.savedText)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }